import { render, staticRenderFns } from "./WithdrawCommission.vue?vue&type=template&id=6f117849"
import script from "./WithdrawCommission.vue?vue&type=script&lang=js"
export * from "./WithdrawCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports